import { render, staticRenderFns } from "./ConsultationPageDoctor.vue?vue&type=template&id=5b2ea02a&scoped=true&"
import script from "./ConsultationPageDoctor.vue?vue&type=script&lang=js&"
export * from "./ConsultationPageDoctor.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationPageDoctor.vue?vue&type=style&index=0&id=5b2ea02a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ea02a",
  null
  
)

export default component.exports